import { Spin } from 'antd';
import { getYear, getMonth, getISOWeek } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import PieChart from './components';
import { fetchCleaningTaskCompletionList } from './state/operation';
import * as selector from './state/selector';
import { TIME_TYPE } from './util/constant';

export const CleaningTaskCompletion = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.CLEANING_REPORT);
  const [timeTaskCompletion, setTimeTaskCompletion] = useState(TIME_TYPE.Year);
  const dispatch = useDispatch();
  useEffect(() => {
    const today = new Date();
    const timeFilter = {
      isoYear: null,
      isoMonth: null,
      isoWeek: null
    };
    switch (timeTaskCompletion) {
      case TIME_TYPE.Year: {
        const year = getYear(today);
        timeFilter.isoYear = year;
        break;
      }
      case TIME_TYPE.Month: {
        const month = getMonth(today);
        timeFilter.isoMonth = month;
        break;
      }
      default: {
        const week = getISOWeek(today);
        timeFilter.isoWeek = week;
        break;
      }
    }
    dispatch(fetchCleaningTaskCompletionList(timeFilter));
  }, [dispatch, timeTaskCompletion]);

  const { cleaningTaskCompletionInfo } = useSelector((state) => ({
    cleaningTaskCompletionInfo: selector.selectCleaningTaskCompletionInfo(state)
  }));

  const handleTimeTaskCompletion = (value) => {
    setTimeTaskCompletion(value);
  };

  const pieChartData = useMemo(() => {
    if (!cleaningTaskCompletionInfo.data.length) {
      return [];
    }

    return cleaningTaskCompletionInfo.data.map((value) => {
      const taskCompletionType = value.type.toUpperCase();
      return {
        ...value,
        type: t(`taskCompletionMapping.${taskCompletionType}`)
      };
    });
  }, [cleaningTaskCompletionInfo.data, t]);

  return (
    <div className="cleaningReports">
      <div className="cleaningReports-title">
        {t('taskCompletionPanel.title')}
      </div>

      <Spin spinning={cleaningTaskCompletionInfo.isLoading}>
        <div className="cleaningReports-chart">
          <div className="cleaningReports-chart_header">
            <div>
              <span
                className={
                  timeTaskCompletion === TIME_TYPE.Year ? 'active_title' : ''
                }
                onClick={() => handleTimeTaskCompletion(TIME_TYPE.Year)}
                aria-hidden="true"
                data-testid="time-year">
                {' '}
                {t('taskCompletionPanel.thisYear')}{' '}
              </span>{' '}
              |
              <span
                className={
                  timeTaskCompletion === TIME_TYPE.Month ? 'active_title' : ''
                }
                onClick={() => handleTimeTaskCompletion(TIME_TYPE.Month)}
                aria-hidden="true"
                data-testid="time-month">
                {' '}
                {t('taskCompletionPanel.thisMonth')}{' '}
              </span>{' '}
              |
              <span
                className={
                  timeTaskCompletion === TIME_TYPE.Week ? 'active_title' : ''
                }
                onClick={() => handleTimeTaskCompletion(TIME_TYPE.Week)}
                aria-hidden="true"
                data-testid="time-week">
                {' '}
                {t('taskCompletionPanel.thisWeek')}{' '}
              </span>
            </div>
          </div>

          <div className="cleaningReports-chart_content">
            {pieChartData.length ? <PieChart data={pieChartData} /> : null}
          </div>
        </div>
      </Spin>
    </div>
  );
};
